import React from 'react';

class ShareBtn extends React.Component {

    state = {
        isOpened: false
    };

    render() {
        const toggleShare = () => {
            this.setState({
                isOpened: !this.state.isOpened
            })
        };

        const openFB = () =>  {
            var url = "https://www.facebook.com/dialog/share?app_id=140586622674265&display=popup&href="+encodeURI(window.location.href);
		    window.open(url, '_about');
        }

        const openTwitter = () => {
            var url = 'https://twitter.com/intent/tweet?text=English&url='+encodeURI(window.location.href);
		    window.open(url, '_blank');
        }

        const openLinkedIn = () => {
            var url = 'https://www.linkedin.com/cws/share?url='+encodeURI(window.location.href);
		    window.open(url, '_blank');
        }

        const openWeChat = () => {
            var url = 'http://api.addthis.com/oexchange/0.8/forward/wechat/offer?url='+encodeURI(window.location.href);
		    window.open(url, "_blank");
        }

        return(
            <li className="mobile_hide" onClick={toggleShare}><a href="#asd" id="shareBtn" className="mhide">Share</a>
                <div className={this.state.isOpened === true ? 'show addthis_toolbox' : 'hide'}>
                    <div className="custom_images">
                        <a className="addthis_button_facebook" title="Facebook" href="#" onClick={openFB}>
                            <img src='/VialSelector/images/Facebook.png' alt="Share to Facebook"/>
                                Facebook
                        </a>
                                
                        <a className="addthis_button_twitter" title="Twitter" href="#" onClick={openTwitter}>
                            <img src='/VialSelector/images/Twitter.png' alt="Share to Twitter"/>
                            Twitter
                        </a>
                            
                        <a className="addthis_button_linkedin" title="LinkedIn" href="#" onClick={openLinkedIn}>
                            <img src='/VialSelector/images/LinkedIn.png' alt="Share to LinkedIn"/>
                            LinkedIn
                        </a>
                                
                        <a className="addthis_button_wechat" title="WeChat" href="#" onClick={openWeChat}>
                            <img src='/VialSelector/images/we-chat.png' alt="Share to WeChat"/>
                            WeChat
                        </a>
                                
                        <a className="addthis_button_whatsapp" target="_blank" title="WhatsApp" href="https://www.whatsapp.com/">
                            <img src='/VialSelector/images/whats-app.png' alt="Share to WhatsApp"/>
                            WhatsApp
                        </a>
                    </div>
                    <div className="atclear"></div>
                </div>
            </li>
        );
    }
}

export default ShareBtn;